import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('targetTypes', { startValue: undefined });
